export enum HtmlStyleType {    
    Text = 1,
    Bold = 2,
    Variable = 3
}export enum MiscEmailEntity {    
    NddExportable = 1,
    NddRegistered = 2,
    RccapDeadlineMissed = 3,
    RccapRequest = 4,
    SwapQualityIssueReported = 5
}export enum MiscEmailType {    
    NewNdd = 1,
    Rccap = 2,
    SwapQualityIssue = 3,
    Referral = 4,
    NewInformationRequest = 5
}export enum MiscNewNddId {    
    Exportable = 1,
    Registered = 2
}export enum MiscRccapId {    
    Request = 1,
    DeadlineMissed = 2
}export enum MiscSwapQualityIssueId {    
    IssueReported = 1
}export enum MiscReferralId {    
    Ndd = 1,
    Patient = 2
}export enum MiscNewInformationRequestId {    
}export enum DcnDonorTrackingType {    
    ReferralNotice = 1,
    ContactMade = 2,
    FollowUpContactMade = 3,
    RedirectDonor = 4,
    NeedWorkUpDate = 5,
    WentToWorkup = 6,
    SurgeryDate = 7,
    PreOpComplete = 8,
    DonateComplete = 9,
    FollowUp = 10
}export enum FreshBloodEmailType {    
    RequestNotice = 1,
    CancellationNotice = 2,
    KitShippedNoticeInstitutional = 3,
    KitReceivedNotice = 4,
    BloodShippedNotice = 5,
    BloodReceivedNotice = 6,
    BloodNotReceivedNotice = 7,
    ResultsReported = 8,
    ResultsNotReported = 9
}export enum FreshBloodRequestNoticeId {    
    Dc1 = 1,
    D2 = 2,
    Ph3 = 3,
    Dc4 = 4,
    D5 = 5,
    Ph6 = 6,
    Dc7 = 7,
    D8 = 8,
    Ph9 = 9,
    Dc10 = 10,
    D11 = 11,
    Ph12 = 12,
    Dc13 = 13,
    D14 = 14,
    Ph15 = 15
}export enum FreshBloodCancellationNoticeId {    
    Dc16 = 1,
    D17 = 2,
    Ph18 = 3,
    Dc19 = 4,
    D20 = 5,
    Ph21 = 6,
    Dc22 = 7,
    D23 = 8,
    Ph24 = 9,
    Dc25 = 10,
    D26 = 11,
    Ph27 = 12,
    Dc28 = 13,
    D29 = 14,
    Ph30 = 15
}export enum FreshBloodKitShippedNoticeInstitutionalId {    
    Dc31 = 1,
    D32 = 2,
    Ph33 = 3,
    Dc34 = 4,
    D35 = 5,
    Ph36 = 6,
    Dc37 = 7,
    D38 = 8,
    Ph39 = 9,
    Dc40 = 10,
    D41 = 11,
    Ph42 = 12,
    Dc43 = 13,
    D44 = 14,
    Ph45 = 15
}export enum FreshBloodKitReceivedNoticeId {    
    Notice46 = 1
}export enum FreshBloodShippedNoticeId {    
    Notice47 = 1,
    Notice48 = 2,
    Notice49 = 3,
    Notice50 = 4,
    Notice51 = 5
}export enum FreshBloodReceivedNoticeId {    
    Notice52 = 1,
    Notice53 = 2,
    Notice54 = 3,
    Notice55 = 4,
    Notice56 = 5
}export enum FreshBloodNotReceivedNoticeId {    
    Notice57 = 1,
    Notice58 = 2,
    Notice59 = 3,
    Notice60 = 4,
    Notice61 = 5
}export enum FreshBloodResultsReportedId {    
    Notice62 = 1,
    Notice63 = 2,
    Notice64 = 3,
    Notice65 = 4,
    Notice66 = 5
}export enum FreshBloodResultsNotReportedId {    
    Notice68 = 1,
    Notice69 = 2,
    Notice70 = 3,
    Notice71 = 4,
    Notice72 = 5
}export enum CryoEmailType {    
    RequestNotice = 1,
    RequestCancellationNotice = 2,
    KitShippedNotice = 3,
    DonorFactSheet = 4,
    CellsReceivedNotice = 5,
    CellsNotReceivedNotice = 6,
    ResultsReportedNotice = 7,
    ResultsNotReportedNotice = 8
}export enum CryoRequestNoticeId {    
    Rc1 = 1,
    Vibt2 = 2,
    Dc3 = 3,
    Rc7 = 4,
    Vibt8 = 5,
    Dc9 = 6
}export enum CryoRequestCancellationNoticeId {    
    Rc4 = 1,
    Vibt5 = 2,
    Dc6 = 3,
    Rc10 = 4,
    Vibt11 = 5,
    Dc12 = 6
}export enum CryoKitShippedNoticeId {    
    Rc13 = 1,
    Rc14 = 2
}export enum CryoDonorFactSheetId {    
    DonorFactSheet = 1
}export enum CryoCellsReceivedNoticeId {    
    Notice16 = 1,
    Notice17 = 2
}export enum CryoCellsNotReceivedNoticeId {    
    Notice18 = 1,
    Notice19 = 2
}export enum CryoResultsReportedNoticeId {    
    Notice20 = 1,
    Notice21 = 2
}export enum CryoResultsNotReportedNoticeId {    
    Notice22 = 1,
    Notice23 = 2
}export enum OffersEmailType {    
    Offer = 1,
    Rexm = 2,
    CommenceXmAndDonorReview = 3,
    Logistics = 4,
    KickOff = 5,
    CommenceSwap = 6,
    PostSurgery = 7
}export enum OfferRexmId {    
    RexmNotification = 1,
    SingleAvoidRexm = 2
}export enum RexmId {    
    NA = 0
}export enum CommenceXmAndDonorReviewId {    
    NA = 0
}export enum LogisticsId {    
    NA = 0
}export enum KickoffId {    
    NA = 0
}export enum CommenceSwapId {    
    NA = 0
}export enum PostSurgeryId {    
    NA = 0
}export enum OfferEmailEntity {    
    Commence = 1,
    DefaultEmail = 2,
    EmergencyNotification = 3,
    FastTrack = 4,
    KickOffCallMissingPerson = 5,
    KickOffCallReminder = 6,
    KickOffCallRescheduled = 7,
    KickOffCallScheduled = 8,
    LogisticsCallMissingPerson = 9,
    LogisticsCallReminder = 10,
    LogisticsCallRescheduled = 11,
    LogisticsCallScheduled = 12,
    MatchAccepted = 13,
    MatchCancelled = 14,
    MatchDeadlineMissed = 15,
    MatchDeclined = 16,
    MatchOffer = 17,
    PatientUpdate = 18,
    RexmNotification = 19,
    SlowTrackMatchOffer = 20,
    SwapCommenced = 21,
    XmDrAcceptable = 22,
    XmDrDeadlineMissed = 23,
    XmDrUnacceptable = 24
}export enum BloodTestingEmailEntity {    
    CryoExm = 1,
    FreshExm = 2,
    FreshSxm = 3,
    FreshFxm = 4,
    Rexm = 5
}